// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountGetAccountDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountGetAccountDefaultResponse.attributeTypeMap;
    }
}
SiteAccountGetAccountDefaultResponse.discriminator = undefined;
SiteAccountGetAccountDefaultResponse.additionalProperties = false;
SiteAccountGetAccountDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetAccountResponseModel"
    },
];
//# sourceMappingURL=siteAccountGetAccountDefaultResponse.js.map